/**
 *
 *
 * THIS FILE IS SHARED BETWEEN THE CLIENT AND SERVER.
 *
 * DO NOT ADD ANYTHING SERVER-SPECIFIC TO THIS FILE.
 *
 *
 *
 */
export const LABEL_MONITORING_GROUP = 'monitoring_group';

// checkout
export const LABEL_VALUE_MONITORING_GROUP_CHECKOUT = 'checkout';
export const LABEL_VALUE_MONITORING_GROUP_CHECKOUT_DELIVERY_PRE_RENDER =
    'checkout_delivery_prerender';
export const LABEL_VALUE_MONITORING_GROUP_CHECKOUT_DELIVERY = 'checkout_delivery';
export const LABEL_VALUE_MONITORING_GROUP_CHECKOUT_ITEM_BUYER_PRE_RENDER =
    'checkout_item_buyer_prerender';
export const LABEL_VALUE_MONITORING_GROUP_CHECKOUT_ITEM_BUYER = 'checkout_item_buyer';
export const LABEL_VALUE_MONITORING_GROUP_CHECKOUT_SUBMISSION = 'checkout_submission';
export const LABEL_VALUE_MONITORING_GROUP_CHECKOUT_PAGE = 'checkout_page'; // Used for the HTML page

// ToF
export const LABEL_VALUE_MONITORING_GROUP_PDP = 'pdp';
export const LABEL_VALUE_MONITORING_GROUP_SEARCH = 'search';
export const LABEL_VALUE_MONITORING_GROUP_BROWSE = 'browse';
export const LABEL_VALUE_MONITORING_GROUP_BUY = 'buy';
export const LABEL_VALUE_MONITORING_GROUP_HOMEPAGE = 'homepage';

// BOMT
export const LABEL_VALUE_MONITORING_GROUP_BOMT = 'bomt'; // Used for the graphql query that loads orders for the BOMT
export const LABEL_VALUE_MONITORING_GROUP_BOMT_ACTION = 'bomt_action'; // Used for all mutations that update orders in the BOMT

// message center
export const LABEL_VALUE_MONITORING_GROUP_MC = 'messagecenter'; // Used for MC gql queries
export const LABEL_VALUE_MONITORING_GROUP_MC_PAGE = 'mc_page'; // Used for the HTML page

// dealer message center
export const LABEL_VALUE_MONITORING_GROUP_DEALER_MC_INBOX = 'dmc_inbox';
export const LABEL_VALUE_MONITORING_GROUP_DEALER_MC_CONVERSATION = 'dmc_convo';
export const LABEL_VALUE_MONITORING_GROUP_DEALER_MC_PAGE = 'dmc_page'; // Used for the HTML page

// item upload
export const LABEL_VALUE_MONITORING_GROUP_ITEM_UPLOAD = 'item_upload';
export const LABEL_VALUE_MONITORING_GROUP_ITEM_UPLOAD_SUBMISSSION = 'item_upload_submission';

// DIM
export const LABEL_VALUE_MONITORING_GROUP_DIM = 'dim';

// DOMT
export const LABEL_VALUE_MONITORING_GROUP_DOMT = 'domt';

export const LABEL_VALUE_UNKNOWN = 'unknown';

/**
 * We're VERY strict with monitoring group names. No one is
 * allowed to add one without consulting engineering
 * leadership first.
 */
export const VALID_LABEL_VALUES_MONITORING_GROUP = [
    // checkout
    LABEL_VALUE_MONITORING_GROUP_CHECKOUT,
    LABEL_VALUE_MONITORING_GROUP_CHECKOUT_DELIVERY_PRE_RENDER,
    LABEL_VALUE_MONITORING_GROUP_CHECKOUT_DELIVERY,
    LABEL_VALUE_MONITORING_GROUP_CHECKOUT_ITEM_BUYER_PRE_RENDER,
    LABEL_VALUE_MONITORING_GROUP_CHECKOUT_ITEM_BUYER,
    LABEL_VALUE_MONITORING_GROUP_CHECKOUT_SUBMISSION,
    LABEL_VALUE_MONITORING_GROUP_CHECKOUT_PAGE,

    // ToF
    LABEL_VALUE_MONITORING_GROUP_PDP,
    LABEL_VALUE_MONITORING_GROUP_SEARCH,
    LABEL_VALUE_MONITORING_GROUP_BROWSE,
    LABEL_VALUE_MONITORING_GROUP_BUY,
    LABEL_VALUE_MONITORING_GROUP_HOMEPAGE,

    // BOMT
    LABEL_VALUE_MONITORING_GROUP_BOMT,
    LABEL_VALUE_MONITORING_GROUP_BOMT_ACTION,

    // buyer message center
    LABEL_VALUE_MONITORING_GROUP_MC,
    LABEL_VALUE_MONITORING_GROUP_MC_PAGE,

    // dealer message center
    LABEL_VALUE_MONITORING_GROUP_DEALER_MC_INBOX,
    LABEL_VALUE_MONITORING_GROUP_DEALER_MC_CONVERSATION,
    LABEL_VALUE_MONITORING_GROUP_DEALER_MC_PAGE,

    // item upload
    LABEL_VALUE_MONITORING_GROUP_ITEM_UPLOAD,
    LABEL_VALUE_MONITORING_GROUP_ITEM_UPLOAD_SUBMISSSION,

    // DIM
    LABEL_VALUE_MONITORING_GROUP_DIM,

    // DOMT
    LABEL_VALUE_MONITORING_GROUP_DOMT,

    LABEL_VALUE_UNKNOWN,
] as const;

export type VALID_MONITORING_GROUP_VALUES = typeof VALID_LABEL_VALUES_MONITORING_GROUP[number];

export const isValidMonitoringGroup = (v: unknown): v is VALID_MONITORING_GROUP_VALUES =>
    typeof v === 'string' &&
    VALID_LABEL_VALUES_MONITORING_GROUP.includes(v as VALID_MONITORING_GROUP_VALUES);
